<template>
  <div class="w-table-wrap" style="max-height: 1200px;">
    <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
      <w-card title-class="blue-dark4--bg white" style="font-size: 11px;" :title="'SENARAI KES'" >
          <template #title>
            SENARAI KES
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedList = !isMinimizedList">
                  <template v-if="isMinimizedList">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
        </template>
        <div v-show="!isMinimizedList">
        <div class="w-table-wrap" style="max-height: 1400px;" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " style="line-height: 35px">
            <table >
              <tbody>
              <tr class="row_data">
                 <td><b>Tarikh AI</b><i aria-hidden="true" style=" color: red;">*</i></td>
                 <td><b>:</b></td>
                 <td>
                  <template v-if="(datas.lkp_status_id==34 && datas.pemeriksaan!=1) || datas.lkp_status_id==32 || datas.lkp_status_id==27">
                  <w-input type="date" v-model="datas.tarikh_ai" outline :validators="[validators.required]"></w-input>
                  </template>
                  <template v-else>
                    {{$zutil.dateformat(datas.tarikh_ai)}}
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br>
        <div class="table-profil-scrol">
          <table class="w-table" color="light" >
            <thead>
              <tr>
                <th class="w-table__header  text-center" width="1%">BIL</th>
                <th class="w-table__header  text-center">NO KES AI</th>
                <th class="w-table__header  text-center">ID/ NAMA TERNAKAN</th>
                <!-- <th class="w-table__header  text-center">PENENTUAN AI<i aria-hidden="true" style=" color: red;">*</i></th> -->
                <th class="w-table__header  text-center">SUMBER SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">JENIS SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">ID TERNAKAN | NO BATCH SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">HARGA SEMEN PER STRAW(RM)</th>
                <th class="w-table__header  text-center">NO. INSEMINASI</th>
                <th class="w-table__header  text-center">BIL STRAW SEMEN<i aria-hidden="true" style=" color: red;">*</i></th>
                <th class="w-table__header  text-center">TARIKH JANGKAAN PD<i aria-hidden="true" style=" color: red;">*</i></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="ternakan_list.length == 0">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
                </tr>
              </template>
              <template v-for="(dt, ind) in ternakan_list">
                <tr class="w-table__row" >
                  <td class="w-table__cell text-left" >{{ind+1}}</td>
                  <td class="w-table__cell text-left" style="margin:5px;"><div style="width: 210px"></div>{{dt.no_kes}}</td>
                  <td class="w-table__cell text-left" style="margin:3px;"><div style="width: 210px"></div>{{dt.ternakan_nama}}</td>
                  <!-- <td class="w-table__cell text-left"><div style="width: 210px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                      {{dt.lkp_penentuan_ai}}
                    </template>
                    <template v-else>
                      <w-select style="margin:10px;" placeholder="Pilih Satu.." outline :items="lkp_penentuan_ai" v-model="dt.lkp_penentuan_ai_id" :validators="[validators.required]"/>
                    </template>
                  </td> -->
                  <td class="w-table__cell text-left" style="margin:15px;"><div style="width: 210px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                      {{dt.lkp_kategori_semen}}
                    </template>
                    <template v-else>
                      <!-- <w-select style="margin:10px;" placeholder="Pilih Satu.." outline :items="kategori_semen" v-model="dt.lkp_kategori_semen_id" :validators="[validators.required]"/> -->
                      <w-select style="margin:10px;" placeholder="Pilih Satu.." outline :items="kategori_semen" v-model="dt.lkp_kategori_semen_id"  :validators="[validators.required]"/>
                    </template>
                  </td>
                  <td class="w-table__cell text-left" style="margin:10px;"><div style="width: 190px"></div>
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                     {{dt.jenis_semen_ket}}
                     </template>
                     <template v-else>
                        <w-select style="margin:10px;" label='' placeholder="Pilih Satu.." outline @input="lookupStock(dt)" :items="lkp_baka" v-model="dt.jenis_semen" :validators="[validators.required]"/>
                     </template>
                  </td>
                  <td class="w-table__cell text-left" style="margin:10px;"><div style="width: 320px"></div>
                     <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27 || dt.lkp_status_id == 28">
                         {{dt.no_batch_keterangan}}
                        </template>
                        <template v-else>
                         <!-- <z-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt)" outline :items="dt.list_stock" v-model="dt.se_stock_id" :validators="[validators.required]"/> -->
                         <!-- {{dt.list_stock.length}} {{dt.lkp_kategori_semen_id}} -->
                                <table width="100%">
                                  <tbody>
                                  <tr>
                                    <td v-if="dt.lkp_kategori_semen_id == 3">
                                        <template v-if="dt.list_stock.length == 0">
                                          <template v-if="dt.no_batch_keterangan">
                                            {{dt.no_batch_keterangan}}
                                          </template>
                                          <template v-else>
                                           Tiada stok semen
                                         </template>
                                        </template>
                                        <template v-else>
                                            <w-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt, 1)" outline :items="dt.list_stock" v-model="dt.se_stock_id" :validators="[validators.required]"/>
                                      </template>
                                    </td>
                                    <td v-else>
                                        <template v-if="dt.list_stock.length == 0">

                                           <template v-if="dt.no_batch_keterangan">
                                            {{dt.no_batch_keterangan}}
                                          </template>
                                          <template v-else>
                                           Tiada stok semen
                                         </template>
                                        </template>
                                        <template v-else>
                                            <w-select style="margin:10px;" label='' placeholder="Pilih Satu.."  @input="getHarga(dt, 1)" outline :items="dt.list_stock" v-model="dt.se_stock_id" :validators="[validators.required]"/>
                                        </template>
                                    </td>
                                    <!-- <td v-if="dt.lkp_kategori_semen_id == 3 && (dt.list_stock.length == 0)"> -->
                                    <td v-if="dt.lkp_kategori_semen_id == 3 ">
                                      <w-button dark class="green--bg ml1" @click="perekodanNew(dt)" >
                                        <w-icon class="mr1">fal fa-plus</w-icon> 
                                    </w-button>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                      </template>
                  </td>
                  <td class="w-table__cell text-right" style="margin:5px;">
                     <template v-if="dt.lkp_kategori_semen_id==3 && (datas.lkp_status_id==27||datas.lkp_status_id==34)">
                        <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="dt.harga_straw" outline :validators="[validators.required]"/>
                     </template>
                     <template v-else>
                        {{$zutil.formatDecimal(dt.harga_straw)}}
                     </template>
                  </td>
                  <td class="w-table__cell text-right" style="margin:5px;">
                      {{dt.bil_inseminasi}}
                  </td>
                  <td class="w-table__cell text-right" style="margin:5px;"><div style="width: 120px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                      {{dt.bil_straw}}
                    </template>
                    <template v-else>
                      <!-- <w-input style="margin:5px;" class="mt4" outline v-model="dt.bil_straw" @keyup="cekBakiStraw(dt)" :validators="[validators.required]" :disabled="!dt.se_stock_id"/> -->
                      <w-input style="margin:5px;" class="mt4" outline v-model="dt.bil_straw" @keyup="cekBakiStraw(dt)" :disabled="!dt.se_stock_id && dt.lkp_kategori_semen_id!=3"/>
                    </template>
                  </td>
                  <td class="w-table__cell text-center" style="margin:3px;"><div style="width: 210px"></div>
                    <template v-if="datas.perkhidmatan==1 && datas.lkp_status_id!=27">
                      {{$zutil.dateformat(dt.jankaan_biang_semula)}}
                    </template>
                    <template v-else>
                      <w-input type="date" outline v-model="dt.jankaan_biang_semula" :validators="[validators.required]"></w-input>
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        </div>
        </div>
      </w-card><br>
      <w-card title-class="blue-dark4--bg white" style="font-size: 11px;" :title="'CAJ PERKHIDMATAN AI'" >
            <template #title>
            CAJ PERKHIDMATAN AI
            <w-flex justify-end class="mt2">
               <w-button @click="isMinimizedCaj = !isMinimizedCaj">
                  <template v-if="isMinimizedCaj">
                     <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                  </template>
                  <template v-else>
                     <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                  </template>
               </w-button>
            </w-flex>
        </template>
        <div v-show="!isMinimizedCaj">
          <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>1.</b></td>
                     <td><b>Konsultasi / Perkhidmatan</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <w-radios
                             :items="ya_tidak"
                             v-model="datas.konsutasi_ya_tidak"
                             @input="kiraan_caj(datas)"
                             inline class="mr2"
                             >
                           </w-radios>
                        </div>
                        <div v-else>
                           <w-tag
                             class="mr4"
                             bg-color="primary"
                             round>
                              <template v-if="datas.konsutasi_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                           </w-tag>
                        </div>
                     </td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
            <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td>RM</td>
                     <td>
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                        <div style="margin:5px;" class="fw-normal my1 fs-1"><z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.konsutasi" @input="kiraan_caj(datas)"  outline/></div>
                        </div>
                        <div v-else>
                          {{$zutil.formatDecimal(datas.konsutasi)}}
                        </div>
                     </td>
                     <td></td>
                     <td></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>

         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
            <table class="w-table" color="light" >
              <thead>
                <tr>
                  <td><b>2. </b></td>
                  <td align="left"><b>HARGA SEMEN</b></td>
                  <td align="center"><b>ID TERNAKAN | NO BATCH</b></td>
                  <td align="center"><b>HARGA (RM)</b></td>
                  <td align="center"><b>KUANTITI</b></td>
                  <td align="center"><b>JUMLAH (RM)</b></td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td align="left">i. SEMEN SUBSIDI JABATAN (IBVK) </td>
                  <td align="center">
                     <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                     {{stock.no_batch_keterangan}}
                     </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                     <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                     {{$zutil.formatDecimal(stock.harga)}}
                      </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="ibvk.length ==0">-</div>
                     <div v-for="stock in ibvk" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>ii. SEMEN SUBSIDI JABATAN (NEGERI)</td>
                  <td align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{stock.no_batch_keterangan}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{$zutil.formatDecimal(stock.harga)}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="negri.length ==0">-</div>
                     <div v-for="stock in negri" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>iii. SEMEN PERSENDIRIAN</td>
                  <td align="center">
                     <div v-if="persendirians.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{stock.no_batch_keterangan}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="persendirians.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{$zutil.formatDecimal(stock.harga)}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="persendirians.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{stock.kuantiti}}
                    </div>
                  </td>
                  <td class="w-table__cell text-center" align="center">
                    <div v-if="persendirians.length ==0">-</div>
                     <div v-for="stock in persendirians" v-else>
                    {{$zutil.formatDecimal(stock.total_harga)}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
         </div>
         <div class="w-flex wrap smd-column" >
            <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>3.</b></td>
                     <td><b>Caj Perjalanan (RM)</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           {{$zutil.formatDecimal(datas.pengangkutan)}}
                        </div> 
                     </td>
                  </tr>
                  <tr class="row_data">
                     <td><div style="margin:17px;" class="fw-normal my1 fs-1"></div>  </td>
                     <td>  </td>
                     <td width="30px"></td>
                     <td width="10px"><b></b></td>
                     <td></td>
                  </tr>
                  <tr class="row_data">
                     <td colspan="2"><b>Jumlah Caj Keseluruhan</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <b>RM {{$zutil.formatDecimal(datas.keseluruhan)}}</b>
                     </td>
                  </tr>
                  <tr class="row_data">
                     <td colspan="2"><b>Jumlah Caj Yang Perlu Dibayar</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <b>RM {{$zutil.formatDecimal(datas.perlu_bayar)}}</b>
                     </td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
            <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>4.</b></td>
                     <td><b>Caj Lain-Lain (Jika Ada) (RM)</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                           <!-- <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.pengangkutan" @input="kiraan_caj(datas)" :validators="[validators.required]" outline/> -->
                           <z-money style="margin:5px;" label="" class="mt4" v-model:originalValue="datas.caj_lain" @input="kiraan_caj(datas)" outline/>
                        </div>
                        <div v-else>
                           <template v-if="datas.caj_lain==null"> -
                           </template>
                           <template v-else>
                           {{$zutil.formatDecimal(datas.caj_lain)}}
                           </template>
                        </div> 
                     </td>
                  </tr>
                  <tr class="row_data" v-if="datas.caj_lain!=''">
                     <td colspan="2"><b>Nyatakan</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <div v-if="datas.lkp_status_id==34||datas.lkp_status_id==27">
                              <z-input style="margin:5px;" label="" class="mt4" v-model="datas.nyatakan" @input="kiraan_caj(datas)" placeholder="Sila Masukan.." :validators="[validators.required]" outline/>
                        </div>
                        <div v-else>
                            {{datas.nyatakan}}
                        </div> 
                     </td>
                  </tr>
                  <tr class="row_data">
                     <td colspan="2"><b>Jumlah Caj Subsidi Kerajaan</b></td>
                     <td width="30px"></td>
                     <td width="10px"><b>:</b></td>
                     <td>
                        <b>RM {{$zutil.formatDecimal(datas.subsidi)}}</b>
                     </td>
                  </tr>
                  <tr class="row_data">
                     <td><div style="margin:17px;" class="fw-normal my1 fs-1"></div></td>
                     <td></td>
                     <td width="30px"></td>
                     <td width="10px"><b></b></td>
                     <td></td>
                  </tr>
                  </tbody>
               </table>
            </div>
            <div class="mx2"></div>
         </div>
       </div>
      </w-card>
      <br>

      <w-flex class="mt3" wrap align-center justify-end v-if="(datas.lkp_status_id==34)||(datas.perkhidmatan==1 && datas.lkp_status_id==27)">
        <w-button class="my1" :loading="loading" :disabled="loading" type="submit">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
      </w-flex>
    </w-form>
  </div>

    <w-dialog
          v-model="dialogPerekodanNew.show"
          :fullscreen="dialogPerekodanNew.fullscreen"
          width="800"
          :persistent="dialogPerekodanNew.persistent"
          :persistent-no-animation="dialogPerekodanNew.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                  TAMBAH PEREKODAN
        </template>
            <div class="w-flex wrap smd-column" >
                <div class="grow " >

                <w-form ref="form" v-model="dialogPerekodanNew.valid" @validate="submitPerekodan" @success="success">
                    <!-- {{se_pengeluaran}} -->

                    <!-- {{form.dat}} -->
                    <w-input class="mt4" label="Tarikh Pendaftaran*" type="date" v-model="form.tarikh" :validators="[validators.required]"/>
                    <!-- <template v-if="form.id == 0"> -->
                       <!-- <z-select class="mt4" :items="se_pengeluaran" @input="pilihNoBatch" label="No Batch *"  v-model="form.se_pemungutan_id" :validators="[validators.required]"/> -->
                    <!-- <div class="spacer"></div>
                    <br>
                    <w-input label="No Batch *" v-model="form.no_batch" :validators="[validators.required]"/>
                    <div class="spacer"></div> -->
                    <br>
                    <w-input label="Nama Pengeluar Semen *" v-model="form.nama_pengeluar_s" :validators="[validators.required]"/>
                   <z-select class="mt4" :items="lkp_negara" label="Negara Pengeluar Semen *" @input="pilihNegara" v-model="form.lkp_negara_id" :validators="[validators.required]"/>
                    <br>
                    <table width="100%">
                      <tbody>
                        <tr>
                            <td width="80%">
                                 <z-select class="mt4" :items="se_katalog" label="ID Ternakan*" @input="pilihNoBatch" v-model="form.se_katalog_id" :validators="[validators.required]"/>
                            </td>
                            <td width="20%">
                                 <w-button dark class="green--bg ml1" @click="KategoriNew" >
                            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH KATALOG
                        </w-button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                       
                   
                    <div class="spacer"></div>
                    <br>
                    <w-input label="Nama Ternakan" v-model="form.nama_ternakan" readonly/>
                    <div class="spacer"></div>
                    <br>
                    <w-input label="Baka" v-model="form.baka" readonly/>
                    <div class="spacer"></div>
                    <br>
                    <!-- <w-input label="Tarikh Pengeluaran" type="date" v-model="form.tarikh_pengeluaran"/>
                    <div class="spacer"></div>
                    <br> -->
                    <!-- <w-input label="Bilangan Straw Dikeluarkan*" type="number" v-model="form.bil_straw" :validators="[validators.required]"/> -->
                    <!-- <br> -->
                    <w-input label="Bilangan Straw Didaftarkan*" type="number" v-model="form.baki" :validators="[validators.required]"/>
                    <br>
                    <z-money class="mt4" label="Harga Perstraw (RM) *" v-model:originalValue="form.harga" :validators="[validators.required]"/>
                 </w-form>
                </div>
          
            </div>
          
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogPerekodanNew.show = false">TUTUP</w-button>
            <w-button class="ml1" :loading="dialogPerekodanNew.loading" :disabled="dialogPerekodanNew.valid === false" @click="$refs.form.validate()">SIMPAN</w-button>
         </template>
    </w-dialog>

    <w-dialog
          v-model="dialogKategori.show"
          :fullscreen="dialogKategori.fullscreen"
          width="800"
          :persistent="dialogKategori.persistent"
          :persistent-no-animation="dialogKategori.persistentNoAnimation"
          title-class="primary-dark1--bg white">
        <template #title>
                  TAMBAH KATALOG
        </template>
         <w-form ref="form_kategori" v-model="form_kategori.valid" @validate="validateFormKategori" @success="success">
         <!-- <center>
          <div class="xs4" > -->
          <!--   <vueper-slides fade :touchable="false" fixed-height="175px" >
              <vueper-slide v-for="(slide, i) in slides"  :key="i"  :image="slide.image"  />
               </vueper-slides> -->
                  <!-- <template v-if="$zutil.anyRole(['1', '3', '7', '9'])">
                     <w-input class="mt4" type="file" :preview="false" accept=" image/*" v-model="img" multiple>Muat Naik Gambar</w-input>
                     <template v-for="dt, ind  in attahecmentImg">
                        <div class="fw-normal my1 fs-1">  
                        <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecmentImg(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                        </div>
                     </template>
                  </template>
               <br><br>
             </div>
         </center> -->
            <div class="w-flex wrap smd-column" >
                <div class="grow " >
                    <z-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form_kategori.lkp_ternakan_id" @input="getJurusan(form_kategori.lkp_ternakan_id)" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form_kategori.lkp_jurusan_id" @input="getBaka(form_kategori.lkp_jurusan_id)" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form_kategori.lkp_baka_id"  :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_gred" label="Generasi "  v-model="form_kategori.lkp_gred_id" />
                    <w-select class="mt4" :items="jantina" label="Jantina *"  v-model="form_kategori.jantina"  :validators="[validators.required]" disabled/>
                    
                    <br>
            
                </div>
                  <div class="mx2"></div>
                  <div class="grow " >
                    <br>
                    <w-input label="ID Ternakan *" type="text" v-model="form_kategori.kode"  :validators="[validators.required]"/>
                    <w-input class="mt4" label="Nama Ternakan " type="text" v-model="form_kategori.nama" />
                    <w-input class="mt4" label="Tarikh Lahir *" type="date" v-model="form_kategori.tarikh_lahir" :validators="[validators.required]"/>
                    <z-select class="mt4" :items="kepemilikan" label="Pemilik *"  v-model="form_kategori.kepemilikan"  :validators="[validators.required]"/>
                    <z-select class="mt4" :items="lkp_negara" label="Negara Asal *"  v-model="form_kategori.lkp_negara_id"  :validators="[validators.required]"/>
                     <w-select class="mt4" :items="lkp_status_kategori" label="Status *"  v-model="form_kategori.lkp_status_id"  :validators="[validators.required]" v-if="form_kategori.id > 0"/>
                </div>

                  <div class="mx2"></div>
                  <div class="grow " >
                    <w-input class="mt4" label="Nama Bapa" type="text" v-model="form_kategori.nama_bapa" />
                    <w-input class="mt4" label="ID Bapa" type="text" v-model="form_kategori.id_bapa" />
                    <w-input class="mt4" label="Nama Ibu" type="text" v-model="form_kategori.nama_ibu" />
                    <w-input class="mt4" label="ID Ibu" type="text" v-model="form_kategori.id_ibu" />
                    <w-textarea class="mt4"  label="Ciri-ciri"  v-model="form_kategori.ciri_ciri" />
                    <div class="grow " >
                        <template v-if="$zutil.anyRole(['1', '3', '7', '9'])">
                          <w-input class="mt4" type="file" :preview="false" accept="application/pdf" v-model="files" multiple>Muat Naik Sijil Pedigree dan Prestasi PDF</w-input>
                            <template v-for="dt, ind  in attahecment">
                                <div class="fw-normal my1 fs-1">  
                                  <a :href="dt.url">{{ dt.name }}</a> <w-button  bg-color="error-dark1"  @click="deletelAttahecment(dt.id)" ><w-icon xs >fal fa-trash</w-icon></w-button>
                                </div>
                            </template>
                        </template>
                        <br><br>
                    </div>
                  </div>
             </div>
         </w-form>
        <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialogKategori.show = false">TUTUP</w-button>
            <!-- <w-button class="ml1" :loading="dialogKategori.loading" :disabled="dialogKategori.valid === false" @click="$refs.form.validate()">SIMPAN</w-button> -->
             <w-button class="ml1" :loading="dialogKategori.loading" :disabled="form_kategori.valid === false" @click="$refs.form_kategori.validate()">SIMPAN</w-button>
         </template>
    </w-dialog>
</template>

<script>
export default {
  name: "Pemilik",
  props:{
    d_data: [Array, Object],
    d_segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'art.semakan.sinkronisasi-aiman',
      form : {},
      form_kategori : {
         jantina : 1
      },
      datas : this.d_data,
      lkp_berahi : [],
      loading:false,
      ternakan_list:[],
      list_stock:[],
      lkp_penentuan_ai: [],

      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],

      kepemilikan: [
         {value: 1, label: "IBVK", disabled:this.$zutil.anyRole(['7', '9'])},
         {value: 2, label: "Luar Negara",}
      ],
      kategori_semen: [
        
      ],
      validators: {
          required: (value) => !!value || "Medan ini wajib diisi",
          consent: (value) => !!value || "You must agree",
          email: (value) =>
              !!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i) ||
              "Sila Semak Format Email",
          numeric: (value) => value !== '' || !isNaN(value) || "Medan Ini Wajib Numeric",
      },
      total_harga:0,
      ibvk:{
        no_batch_keterangan:'',
        jumlah: '',
        harga:0.00,
        kuantiti: '',
        total_harga:''
      },
      dvs_negeri:{
        no_batch_keterangan:'',
        jumlah: '',
        harga:0.00,
        kuantiti: '',
        total_harga: ''
      },
      negri:0,
      ibvk:0,
      persendirian:0,
      isMinimizedCaj: false,
      isMinimizedList: false,
      ya_tidak:[
         {value: 1, label: "Berbayar"},
         {value: 2, label: "Subsidi"},
      ],
      listStock:[],
      lkp_baka:[],
      list_stock_1: [],
      lkp_negara:[],
      se_katalog: [],

      lkp_ternakan : [],
      lkp_jurusan : [],
      lkp_baka : [],
      lkp_gred : [],
      lkp_status_kategori : [],
      jantina : [],
      fileCiri2: [],
      files:[],
      img:[],
      attahecment:[],
      attahecmentImg:[],
      attahecmentImg:[],
      persendirians:[],

      dialogPerekodanNew: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 1800,
        item: {}
      },
      dialogKategori: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
          width: 900,
        item: {}
      },
      
    }
  },
  methods:{

    perekodanNew(dt){
         this.form = {
          harga : null,
         }
        // alert(this.form.dat);

        this.dialogPerekodanNew.show = true;
        this.form.saveButton = "Simpan"
        this.getNegara()
        this.getKatalog()
    },

    KategoriNew(){
        this.dialogKategori.show = true;
        this.form.saveButton = "Simpan"
        this.getTernakanKategori()
        this.getGred()
        this.getStatus()
        this.getJantina()

    },
    pilihNoBatch(value){
      for (var i in this.se_katalog) {
         if (this.form.se_katalog_id == this.se_katalog[i].value) {
            // this.form.id_ternakan = this.se_pengeluaran[i].id_ternakan;
            this.form.nama_ternakan = this.se_katalog[i].nama_ternakan;
            this.form.baka = this.se_katalog[i].baka;
            this.form.lkp_negara_id = this.se_katalog[i].lkp_negara_id;
            // this.form.bil_straw = this.se_pengeluaran[i].jumlah_straw;
         }
      }
      // alert('asd');
   },
    getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.lkp_negara = res
      })
    },
    getKatalog(){
      this.$zcomm.get(this.api_service + 'lookup/se_katalog_luar', {}).then(res => {
        this.se_katalog = res
      })
   },
   pilihNegara(value){
      for (var i in this.lkp_negara) {
         if (this.form.lkp_negara_id == this.lkp_negara[i].value) {
            this.form.negara = this.lkp_negara[i].label;
         }
      }
      // alert('asd');
   },

    submitPerekodan() {

        this.form.hantar = 1;
        if (this.form.hantar==1) {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            })
            .then((result) => {
                if (result.value) {
                        this.$zcomm.post('se.perekodan.store' , this.form)
                        .then(res => {
                           this.loading=false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                                this.$zutil.notify("Berjaya disimpan", true);
                                // this.$inertia.visit(this.$route('art.semakan.ai-aiman', this.datas.id));
                                // this.$inertia.visit(this.$route('art.semakan.ai-aiman',this.datas.id)+'?tab=2');
                                this.getStock(1);
                                // this.getTernakan();


                        })
                        .finally(() => {
                            this.dialogPerekodanNew.show = false;
                            
                                

                        });
                }else{ }

            })
        }

    },

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
        this.load = this.load + 1
      })
    },

    getTernakanKategori(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
        this.load = this.load + 1
      })
    },

    getJurusan(i){

      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        this.lkp_jurusan = res
        this.load = this.load + 1
      })
    },

    getBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
        this.load = this.load + 1
      })
    },

    getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.lkp_gred = res
        this.load = this.load + 1
      })
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status', {}).then(res => {
        this.lkp_status_kategori = res
        this.load = this.load + 1
      })
    },

    uploadImg(item) 
    {  
       let formData = new FormData();
       for (var b in this.img) 
       {
           formData.append("files["+b+"]", this.img[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKatalog');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload', formData)
           .then((res) => {
               this.getAttahecmentImg();
           })
           .catch((err) => {})
           .finally(() => {});
   },

   deletelAttahecmentImg(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecmentImg();
       })
     }
   },

    getAttahecmentImg()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SeKatalog'}).then(res => {
        this.attahecmentImg = res
        this.slides = [];
       for (var b in this.attahecmentImg) {
          this.slides.push({title: this.attahecmentImg[b].information, image: this.attahecmentImg[b].url})
       }
      })
    },

    getAttahecment()
    {
      this.$zcomm.get(this.api_service + 'attahecment/list', {model_id : this.form.id, model : '\\App\\Model\\SeKatalogCiri'}).then(res => {
         this.attahecment = res
         // this.slides = [];
         // for (var b in this.attahecment) {
         //    this.slides.push({title: this.attahecment[b].information, image: this.attahecment[b].url})
         // }
      })
    },

    uploadPDF(item) 
    {  
       let formData = new FormData();
       for (var b in this.files) 
       {
           formData.append("files["+b+"]", this.files[b].file);
       }
       formData.append("model",'\\App\\Model\\SeKatalogCiri');
       formData.append("model_id", item);
       this.$zcomm.post('attahecment.upload_replace', formData)
           .then((res) => {
               this.getAttahecment();
           })
           .catch((err) => {})
           .finally(() => {});
   },
   
   deletelAttahecment(id)
   {
    if (confirm('Are you sure to delete this record?')) {
       this.$zcomm.get(this.$route('attahecment.delete', id), {})
       .then(res => {
        this.getAttahecment();
       })
     }
   },
   validateFormKategori() {
      this.loading=true;
      let isValid = true;
         
      if(!this.form_kategori.lkp_ternakan_id || !this.form_kategori.lkp_jurusan_id || !this.form_kategori.lkp_baka_id || !this.form_kategori.lkp_gred_id || !this.form_kategori.jantina || !this.form_kategori.kode || !this.form_kategori.nama || !this.form_kategori.tarikh_lahir || !this.form_kategori.kepemilikan || !this.form_kategori.lkp_negara_id){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.submitKategori();
    },

    submitKategori(){
        this.form_kategori.hantar = 1;
        this.form_kategori.lkp_status_id = 1;
        this.form_kategori.jantina = 1;
        this.form_kategori.kategori = 1;
      if(this.form_kategori.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if(this.form_kategori.id){
                this.$zcomm.update('se.katalog.update', this.form_kategori.id, this.form_kategori)
                .then(res => {
                   this.loading=false;
                  if(this.files.length > 0){
                     this.uploadPDF(res.id);
                  }
                  if (this.img.length > 0) {
                     this.uploadImg(res.id)
                  }
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  else if (this.form_kategori.hantar==1) {
        // alert(1234)
                     this.getKatalog();

                      // this.$inertia.visit(this.$route('se.katalog.show', this.form_kategori.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                     this.getKatalog();
                })
                .finally(() => {
                    this.dialogKategori.show = false;

                });
              }else{
                this.$zcomm.post('se.katalog.store' , this.form_kategori)
                .then(res => {
                   this.loading=false;
                  if(this.files.length > 0){
                     this.uploadPDF(res.id);
                  }
                  if (this.img.length > 0) {
                     this.uploadImg(res.id)
                  }
                  if (typeof this.onAfterAdd === "function") {
                    this.onAfterAdd()
                  }
                  this.$zutil.notify("Berjaya dihantar", true);

                 
                  // this.$inertia.visit(this.$route('se.katalog.show', res.id));
                     this.getKatalog();

                })
                .finally(() => {
                    this.dialogKategori.show = false;

                });
              }
            }
          })
      }
    },
    kiraan_caj(){

      var total_harga = 0;

          // alert('df');
      let ibvk = [];
      ibvk = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id == 1)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let negri = [];
      negri = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id == 2)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      let persendirian = [];
      persendirian = this.ternakan_list
         .filter((item) => item.lkp_kategori_semen_id == 3)
         .map((item) => ({
           no_batch_keterangan: item.no_batch_keterangan,
           kuantiti: item.bil_straw,
           harga: parseFloat(item.harga_straw),
           total_harga: parseFloat(item.harga_straw) * item.bil_straw,
      }));

      const groupBy = (key) => persendirian.sort((a, b) => a[key].localeCompare(b[key])).reduce((total, currentValue) => {
      const newTotal = total;
      if (
         total.length &&
         total[total.length - 1][key] === currentValue[key]
         )
            newTotal[total.length - 1] = {
            ...total[total.length - 1],
            ...currentValue,
            // harga: parseInt(total[total.length - 1].harga) + parseInt(currentValue.harga),
            total_harga: parseInt(total[total.length - 1].total_harga) + parseInt(currentValue.total_harga),
            kuantiti: parseInt(total[total.length - 1].kuantiti) + parseInt(currentValue.kuantiti),
            };
         else newTotal[total.length] = currentValue;
         return newTotal;
      }, []);
      this.persendirians = groupBy('no_batch_keterangan');

      const totalIbvk = ibvk.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalNegri = negri.reduce((accumulator, item) => accumulator + item.total_harga, 0);
      const totalPersendirian = persendirian.reduce((accumulator, item) => accumulator + item.total_harga, 0);

    // Output
    console.log('No Batch List:', ibvk);

      // this.total_harga = total_harga.toFixed(2);
      var no_batch_keterangan = [];
      for (var b in this.ternakan_list){
        if (this.ternakan_list[b].lkp_kategori_semen_id==1) {
          no_batch_keterangan= this.ternakan_list[b].no_batch_keterangan
        }
      }
      this.ibvk = ibvk;
      this.negri = negri;
      this.persendirian = persendirian;
      this.datas.keseluruhan = Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain) + Number(totalIbvk) + Number(totalNegri) + Number(totalPersendirian);
      if(this.datas.jenis_pengguna_pemohon == 1){
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.konsutasi) + Number(this.datas.caj_lain);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri) + Number(this.datas.pengangkutan) + Number(this.datas.caj_lain);
         }
         this.datas.subsidi = subsidi;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi;
      }else{
         if(this.datas.konsutasi_ya_tidak==2){ 
            var subsidi = Number(totalIbvk) + Number(this.datas.konsutasi) + Number(totalNegri);
            // var perlu_bayar = Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }else{
            var subsidi = Number(totalIbvk) + Number(totalNegri);
            // var perlu_bayar = Number(this.datas.konsutasi) + Number(totalPersendirian) + Number(this.datas.caj_lain)+ Number(this.datas.pengangkutan);
         }
         this.datas.subsidi = subsidi;
         this.datas.perlu_bayar = this.datas.keseluruhan - subsidi ;
      }
      // console.log(datas.perlu_bayar)
    },
    lkpPenentuan()
    {
      this.$zcomm.get(this.api_service + 'lookup/penentuan_ai', {}).then(res => {
        this.lkp_penentuan_ai = res
      })
    },
    lkpKategoriSemen()
    {
      this.$zcomm.get(this.api_service + 'lookup/kategori_semen', {}).then(res => {
        this.kategori_semen = res
      })
    },
   lookupStock(dt)
    {
      dt.list_stock = []
      for (var b in this.listStock) {
         if (this.listStock[b].lkp_baka_id == dt.jenis_semen) {
            dt.list_stock.push({ 
               baki: this.listStock[b].baki,
               gred: this.listStock[b].gred,
               harga: this.listStock[b].harga,
               id_betina: this.listStock[b].id_betina,
               id_jantan: this.listStock[b].id_jantan,
               label: this.listStock[b].id_jantan+' | '+this.listStock[b].label,
               stage: this.listStock[b].stage,
               value: this.listStock[b].value,
            });
         }
      }
      
    },

    getStock(ind){
      this.$zcomm.get(this.api_service + 'lookup/stock/1', {}).then(res => {
         this.listStock = res
         if(ind == 1){
          for (var b in this.ternakan_list) {
            if(this.ternakan_list[b].se_stock_id == null || this.ternakan_list[b].se_stock_id == ''){
              this.lookupStock(this.ternakan_list[b])
            }
          }
          
         }
      })
    },
    getHarga(dt, ind){
      if (dt.lkp_kategori_semen_id !=3 && dt.se_stock_id == '' || dt.se_stock_id == null) {
         dt.harga_straw = 0;
         dt.bil_straw = 0;
         this.kiraan_caj();
      }
      for (var b in this.listStock) {
        // if(dt.lkp_kategori_semen_id !=3 && this.listStock[b].value==dt.se_stock_id){
        if( this.listStock[b].value==dt.se_stock_id){
          dt.harga_straw = this.listStock[b].harga;
          dt.max_kuantiti_straw = this.listStock[b].baki;
          if(ind = 1){
            dt.no_batch_keterangan = this.listStock[b].label
          }
        }
      }
    },
    cekBakiStraw(dt){
      if(dt.lkp_kategori_semen_id !=3 && dt.bil_straw > dt.max_kuantiti_straw){
        dt.bil_straw = dt.max_kuantiti_straw;
      }
    },

    getTernakan(){
      // ternakan list
      this.ternakan_list = []
      // this.$zcomm.get(this.api_service + 'art/show/'+this.datas.id, {}).then(res => {

      //   for (var b in res.ternakan_list) {
      //     if(res.ternakan_list[b].bunting==2 && res.ternakan_list[b].status_pemeriksaan ==1){
                for (var b in this.datas.ternakan_list) {
                          if(this.datas.ternakan_list[b].bunting==2 && this.datas.ternakan_list[b].status_pemeriksaan ==1){


            this.getHarga(this.datas.ternakan_list[b], 0);
            this.ternakan_list.push({
              id:this.datas.ternakan_list[b].id,
              art_id:this.datas.ternakan_list[b].art_id,
              bil_inseminasi:this.bilanganInseminasi(),
              bil_straw:this.datas.ternakan_list[b].bil_straw,
              bunting:this.datas.ternakan_list[b].bunting,
              harga_straw:this.datas.ternakan_list[b].harga_straw,
              id_ternakan:this.datas.ternakan_list[b].id_ternakan,
              jankaan_biang_semula:this.jankaanBiangSemula(this.datas.ternakan_list[b].jankaan_biang_semula),
              jankaan_kelahiran:this.datas.ternakan_list[b].jankaan_kelahiran,
              lkpBerahi_keterangan:this.datas.ternakan_list[b].lkpBerahi_keterangan,
              lkp_berahi_id:this.datas.ternakan_list[b].lkp_berahi_id,
              no_kes:this.datas.ternakan_list[b].no_kes,
              se_stock_id:this.datas.ternakan_list[b].se_stock_id,
              skor_badan:this.datas.ternakan_list[b].skor_badan,
              status:this.datas.ternakan_list[b].status,
              ternakan_id:this.datas.ternakan_list[b].ternakan_id,
              usia_bunting:this.datas.ternakan_list[b].usia_bunting,
              usia_bunting:this.datas.ternakan_list[b].usia_bunting,
              list_stock: this.datas.ternakan_list[b].list_stock,
              max_kuantiti_straw:this.datas.ternakan_list[b].max_kuantiti_straw,
              no_batch_keterangan:this.datas.ternakan_list[b].no_batch_keterangan,
              lkp_penentuan_ai_id:this.datas.ternakan_list[b].lkp_penentuan_ai_id,
              lkp_penentuan_ai:this.datas.ternakan_list[b].lkp_penentuan_ai,
              ternakan_nama:this.datas.ternakan_list[b].ternakan_nama,
              lkp_kategori_semen : this.datas.ternakan_list[b].lkp_kategori_semen,
              lkp_kategori_semen_id: this.datas.ternakan_list[b].lkp_kategori_semen_id,
              jenis_semen_ket: this.datas.ternakan_list[b].jenis_semen_ket,
              jenis_semen: this.datas.ternakan_list[b].jenis_semen,
              no_batch: this.datas.ternakan_list[b].no_batch,
              id_ternakan_batch:  this.datas.ternakan_list[b].id_ternakan_batch,
            })
          }
        }
      // });
      this.kiraan_caj();
    },

    //belum benar
    bilanganInseminasi() {
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      const tarikh_sekarang = new Date();

      const batasTanggal = new Date(tarikh_sekarang);
      batasTanggal.setMonth(batasTanggal.getMonth() + 3);
      if(tarikh_pemeriksaan == tarikh_sekarang){
        return 1;
      }else if(tarikh_pemeriksaan > tarikh_sekarang && tarikh_pemeriksaan <= batasTanggal){
        return 2;
      }else if(tarikh_pemeriksaan > batasTanggal){
         return 3;
      }
      return 1;
      // return formattedDate;
    },

    jankaanBiangSemula(tarikh){
      const tarikh_pemeriksaan = new Date(this.datas.tarikh_pemeriksaan);
      tarikh_pemeriksaan.setDate(tarikh_pemeriksaan.getDate() + this.datas.ternakan_biang_semula); //tambah  hari untuk lembu
      const formattedDate = `${tarikh_pemeriksaan.getFullYear()}-${String(tarikh_pemeriksaan.getMonth() + 1).padStart(2, '0')}-${String(tarikh_pemeriksaan.getDate()).padStart(2, '0')}`;
      return formattedDate;
    },

    validateForm() {
      this.loading=true;
      let isValid = true;

      this.ternakan_list.forEach((row) => {
         if (!row.lkp_kategori_semen_id && !row.se_stock_id || !row.bil_straw || !row.jankaan_biang_semula ) {
          isValid = false;
          this.loading=false;
         }
      });

      if (!isValid) {
        this.$zutil.notify("Pastikan semua data sudah diisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.onSuccess();
    },
    send(hantar){
      this.datas.hantar = hantar
    },

    onSuccess(){
      this.loading=true;
      if(this.datas.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.datas.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.datas.id, {ternakan_list:this.ternakan_list, perkhidmatan:1, hantar:1})
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  this.loading=false;
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.permohonan.show', this.datas.id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                      this.$inertia.visit(this.$route('art.semakan.sinkronisasi-aiman',this.datas.id)+'?tab=3');
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }else{
              this.loading=false;
            }
          })
      }else{
        if (this.datas.id > 0) 
        {
          
          var param = {
            ternakan_list: this.ternakan_list,
            perkhidmatan:1,
            tarikh_ai:  this.datas.tarikh_ai,
            konsutasi: this.datas.konsutasi,
            pengangkutan: this.datas.pengangkutan,
            keseluruhan: this.datas.keseluruhan,
            subsidi: this.datas.subsidi,
            perlu_bayar: this.datas.perlu_bayar,
            caj_lain: this.datas.caj_lain,
            konsutasi_ya_tidak: this.datas.konsutasi_ya_tidak,
            nyatakan: this.datas.nyatakan,

          }
          this.$zcomm.update(this.resourceurl + '.update', this.datas.id, param)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            this.loading=false;
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                
                this.$inertia.visit(this.$route('art.semakan.sinkronisasi-aiman',this.datas.id)+'?tab=3');
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
      } 
      
    },
   getbakaAll(){
      this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
        this.lkp_baka = res
      })
   },
  },
      
  mounted() {
    this.lkpPenentuan();
    this.lkpKategoriSemen();
    this.getTernakan();
    this.getStock(0);
    this.getbakaAll()
    // this.datas = this.data;
  }
}
      

</script>  
<style type="text/css">

/*.w-table__row {
  display: flex;
  align-items: center;
}*/
.w-table__cell {
  vertical-align: middle;
}

</style>
